import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './components/theme-provider';
import { MusicPage } from './components/MusicPage';
import { UploadTracksPage } from './components/UploadTracksPage';
import { MusicStatsPage } from './components/MusicStatsPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import ComponentsShowcase from './components/ComponentsShowcase';
import { DarkHolePage } from './components/DarkHolePage';
import { LegalMusicPage } from './components/LegalMusicPage';
function App() {
  useEffect(() => {
    const appStartTime = performance.now();
    console.log(`[App] Приложение инициализировано в ${appStartTime.toFixed(2)}ms`);
    
    // Логируем время загрузки страницы
    window.addEventListener('load', () => {
      const loadTime = performance.now();
      console.log(`[App] Страница полностью загружена за ${loadTime.toFixed(2)}ms`);
    });
  }, []);

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <AuthProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <Routes>
            {/* Главная (/) отдаётся Torus через hosting / devServer rewrite, не React */}
            <Route path="/darkhole" element={<DarkHolePage />} />
            <Route path="/legal" element={<LegalMusicPage />} />
            <Route path="/components" element={<ComponentsShowcase />} />
            
            {/* Защищенные маршруты */}
            <Route 
              path="/app" 
              element={
                <ProtectedRoute>
                  <Navigate to="/app/music" replace />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/app/music" 
              element={
                <ProtectedRoute>
                  <MusicPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/app/music/upload" 
              element={
                <ProtectedRoute>
                  <UploadTracksPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/app/we" 
              element={
                <ProtectedRoute>
                  <MusicStatsPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Редирект на главную для неизвестных маршрутов */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 